<template>
    <md-dialog :md-active="true" class="compareModal">
        <md-dialog-title>{{ getTitle() }}</md-dialog-title>
        <div class="plans">
            <div class="plan old">
                <div class="header">Current Plan: {{ oldPlan.plan.toUpperCase() }}</div>
                <div class="plan-price-section">
                    <div class="plan-price-details">
                        <span class="amount" :class="{ tl: site.basePrice.currency === 'tl' }">{{
                            calculateAgentPrice(oldPlan.agentCount, oldPlan.plan)
                        }}</span>
                        <i>
                            <i class="slash">/</i>
                            <i class="billed-month">{{ $t("billing.month") }}</i>
                        </i>
                    </div>
                </div>
                <a-divider>{{ $t("billing.planDetails") }}</a-divider>
                <div class="features">
                    <div class="feature" v-if="oldPlan.plan === 'pro'">
                        <a-icon type="check" />
                        <span>{{ $t("billing.multiAgentUpTo", { agentCount: oldPlan.agentCount }) }}</span>
                    </div>
                    <div class="feature" v-else>
                        <a-icon type="check" />
                        <span>1 {{ $t("billing.agent") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.videoCallUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.audioCallUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.screenSharingUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.fileTransferUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.autoChatAssignerUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.multiLanguageTranslationUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.detailedReporting") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.fullCustomizationUnlimited") }}</span>
                    </div>
                    <div class="feature" v-if="oldPlan.plan === 'pro'">
                        <a-icon type="check" />
                        <span>{{ $t("billing.ChatBotUnlimited") }}</span>
                    </div>
                    <!--                    <div class="feature" v-if="oldPlan.plan === 'pro'">-->
                    <!--                        <a-icon type="check" />-->
                    <!--                        <span>{{ $t("billing.days30TrialsAvailable") }}</span>-->
                    <!--                    </div>-->
                </div>
            </div>
            <a-icon type="arrow-right" style="margin-left: 10px; font-size: 100px; color: #138412" />
            <div class="plan new">
                <div class="header">Next Plan: {{ newPlan.plan.toUpperCase() }}</div>
                <div class="plan-price-section">
                    <div class="plan-price-details">
                        <span class="amount" :class="{ tl: site.basePrice.currency === 'tl' }">{{
                            calculateAgentPrice(newPlan.agentCount, newPlan.plan)
                        }}</span>
                        <i>
                            <i class="slash">/</i>
                            <i class="billed-month">{{ $t("billing.month") }}</i>
                        </i>
                    </div>
                </div>
                <a-divider>{{ $t("billing.planDetails") }}</a-divider>
                <div class="features">
                    <div class="feature" v-if="newPlan.plan === 'pro'">
                        <a-icon type="check" />
                        <span
                            :class="{
                                'text-success': isUpgrading(),
                                'text-danger': isDowngrading(),
                            }"
                            >{{ $t("billing.multiAgentUpTo", { agentCount: newPlan.agentCount }) }}</span
                        >
                    </div>
                    <div class="feature" v-else>
                        <a-icon type="check" />
                        <span>1 {{ $t("billing.agent") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.videoCallUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.audioCallUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.screenSharingUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.fileTransferUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.autoChatAssignerUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.multiLanguageTranslationUnlimited") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.detailedReporting") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("billing.fullCustomizationUnlimited") }}</span>
                    </div>
                    <div class="feature" v-if="newPlan.plan === 'pro'">
                        <a-icon type="check" class="text-success" />
                        <span>{{ $t("billing.ChatBotUnlimited") }}</span>
                    </div>
                    <div class="feature" v-else>
                        <a-icon type="close" class="text-danger" />
                        <span class="text-danger">{{ $t("billing.ChatBotUnlimited") }}</span>
                    </div>
                    <div class="feature" v-if="isCanceling()">
                        <a-icon type="close" class="text-danger" />
                        <span class="text-danger">{{
                            $t("billing.multiAgentUpTo", { agentCount: oldPlan.agentCount })
                        }}</span>
                    </div>
                    <!--                    <div class="feature" v-if="newPlan.plan === 'pro' && newPlan.plan.agentCount !== 1">-->
                    <!--                        <a-icon type="check" />-->
                    <!--                        <span>{{ $t("billing.days30TrialsAvailable") }}</span>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
        <md-dialog-actions>
            <md-button class="md-primary" @click="onCancel">{{ $t("billing.disagree") }}</md-button>
            <md-button class="md-primary" @click="onApproved">{{ $t("billing.agree") }}</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash";

export default {
    name: "ComparePlans",
    props: {
        newPlan: {
            type: Object,
            default: {
                plan: "Free",
                agentCount: 1,
            },
        },
        oldPlan: {
            type: Object,
            default: {
                plan: "Free",
                agentCount: 1,
            },
        },
        onCancel: {
            type: Function,
            default: () => {},
        },
        onApproved: {
            type: Function,
            default: () => {},
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            settings: (state) => state.setting.settings,
            settingsFetched: (state) => state.setting.settings.initialized,
            isShopify: (state) => _.get(state.site.site, "partner.name") === "shopify",
        }),
    },
    methods: {
        calculateAgentPrice(count, plan) {
            return plan === "free" ? "0" : parseFloat((count * this.site.basePrice.value).toFixed(2));
        },
        getTitle() {
            if (this.isCanceling()) return this.$t("billing.cancelYourPlan");
            if (this.isUpgrading()) return this.$t("billing.upgradeYourPlan");
            if (this.isDowngrading()) return this.$t("billing.downgradeYourPlan");
        },
        isCanceling() {
            return this.newPlan.plan === "free";
        },
        isUpgrading() {
            return this.oldPlan.plan === "free" || this.oldPlan.agentCount < this.newPlan.agentCount;
        },
        isDowngrading() {
            return this.isCanceling() || !this.isUpgrading();
        },
    },
};
</script>

<style lang="scss">
.compareModal {
    .md-dialog-container {
        width: 65% !important;
        overflow: scroll;
    }

    .md-dialog-title {
        text-align: center;
        font-size: 30px;
    }
}
</style>
